<template>
    <section class="home-page__03" :style="`background-image: url(${VIDEO_WORLD_BG})`">
        <video id="home-page03-video" class="bg" preload muted loop :style="`opacity: ${videoShow}`" :src="VIDEO_WORLD" @canplaythrough="loaded"></video>
        <img class="title" src="../../assets/images/home/page03/title.png" alt="title">
        <div class="text">
            <transition-group tag="div" name="text-opacity" class="text_part01">
                <img v-show="textShowIndex >= 0" src="../../assets/images/home/page03/text01.png" alt="" class="text01" key="text01">
                <img v-show="textShowIndex >= 1" src="../../assets/images/home/page03/text02.png" alt="" class="text02" key="text02">
                <img v-show="textShowIndex >= 2" src="../../assets/images/home/page03/text03.png" alt="" class="text03" key="text03">
            </transition-group>
            <transition-group class="text04" tag="div" name="text_lefttoright">
                <img v-show="textShowIndex >= index+2" v-for="index in 14" :key="`text04-${index}`" :src="text04Url(index)" alt="">
            </transition-group>
            <transition-group class="text05" tag="div" name="text_lefttoright">
                <img v-show="textShowIndex >= index+16" v-for="index in 21" :key="`text05-${index}`" :src="text05Url(index)" alt="">
            </transition-group>
        </div>
        <scroll-bar></scroll-bar>
        <pre-login></pre-login>
        <img class="video-play" src="../../assets/images/home/video_play_btn.png" @click="playvideo" alt="">
        <firefly class="left-firefly" zindex="2" dir="left"></firefly>
        <firefly class="right-firefly" zindex="2" dir="right"></firefly>
    </section>
</template>

<script>
import scrollBar from "../../components/scroll-bar";
import preLogin from "../../components/pre-login";
import firefly from "../../components/firefly";

export default {
    name: "home-page03",

    components: {
        "scroll-bar": scrollBar,
        "pre-login": preLogin,
        firefly
    },
    data: () => ({
        videoShow: 0,
        firstShow: true,
        textShowIndex: -1,
        textTimer: null,
    }),
    created() {

    },
    mounted() {
        window.addEventListener('resize', () => {
            this.$utils.setVideoSize("#home-page03-video", ".home-page__03");
        }, false);
    },
    watch: {
        NAV_ACTIVE_INDEX(val) {
            if(val == 3 && this.firstShow) {
                this.firstShow = false;
                this.textTimer = setInterval(() => {
                    this.textShowIndex++;
                    if(this.textShowIndex >= 2) {
                        clearInterval(this.textTimer);
                        this.textTimer = setInterval(() => {
                            this.textShowIndex++;

                            if(this.textShowIndex >= 38) {
                                clearInterval(this.textTimer);
                            }
                        }, 150)
                    }
                }, 1500)
            }
        },
    },
    computed: {
        VIDEO_WORLD() {
            // return this.$store.state.VIDEO_ARR.WORLD;
            return require("../../assets/video/world.mp4")
        },
        VIDEO_WORLD_BG() {
            // return this.$store.state.VIDEO_BG.WORLD;
            return require("../../assets/images/home/page03/bg.png")
        },
        NAV_ACTIVE_INDEX() {		// 导航栏激活指数
            if(this.$store.state.HOME_FULLPAGE) {       // 异步对象
                return this.$store.state.HOME_FULLPAGE.activeIndex;
            } else {
                return -1;
            }
        },
        WORLD_YOTUBE_URL() {
            return this.$store.state.WORLD_YOTUBE_URL;
        }
    },
    methods: {
        formatNum(index) {
            if(index <= 9) {
                return "0" + index;
            } else {
                return index;
            }
        },
        text04Url(index) {
            return require(`../../assets/images/home/page03/text04/text04_${this.formatNum(index)}.png`)
        },
        text05Url(index) {
            return require(`../../assets/images/home/page03/text05/text05_${this.formatNum(index)}.png`)
        },
        playvideo() {
            this.$store.commit("SET_VIDEO", {
                videoUrl: this.WORLD_YOTUBE_URL,
                videoShow: true
            })
        },
        loaded() {
            this.$utils.setVideoSize("#home-page03-video", ".home-page__03");
            this.videoShow = 1;
            document.querySelector("#home-page03-video").play();
        }
    },
    destroyed() {
        if(this.textTimer) {
            clearInterval(this.textTimer);
        }
    }
};
</script>

<style lang="scss" scoped>
.home-page__03 {
    overflow: hidden;
    position: relative;
    background-position: center;
    background-size: cover;

    &::after {
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 2;
        background: rgba(0, 0, 0, 0.3);
    }

    .bg {
        position: absolute;
        /* width: auto;
        height: auto;
        min-width: 100%;
        min-height: 100%; */
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
        
    }
    .title {
        position: absolute;
        z-index: 3;
        height: 100%;
        left: pxTorem(27px);
        opacity: 0.8;
    }
    .text {
        position: absolute;
        z-index: 3;
        width: pxTorem(690px);
        height: pxTorem(550px);
        right: pxTorem(117px);
        bottom: pxTorem(50px);

        .text_part01 {
            text-align: center;
            
            .text01 {
                width: pxTorem(160px);
                margin-bottom: pxTorem(20px);
            }
            .text02 {
                width: pxTorem(540px);
                margin-bottom: pxTorem(40px);
            }
            .text03 {
                width: pxTorem(692px);
                margin-bottom: pxTorem(40px);
            }
        }
        
        .text04 {
            width: 100%;
            display: flex;
            flex-direction: row;
            box-sizing: border-box;
            justify-content: flex-start;
            padding-left: pxTorem(100px);
            margin-bottom: pxTorem(15px);
            
            img {
                height: pxTorem(40px);
            }
        }
        .text05 {
            width: 100%;
            display: flex;
            flex-direction: row;
            box-sizing: border-box;
            justify-content: flex-start;
            padding-left: pxTorem(20px);

            img {
                height: pxTorem(40px);
            }
        }
    }
    .video-play {
        position: absolute;
        z-index: 3;
        width: pxTorem(89px);
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
            transform: scale(1.2);
        }
    }

    .text-opacity-enter-active, .text-opacity-leave-active {
        transition: all 2s;
    }
    .text-opacity-enter, .text-opacity-leave-to {
        opacity: 0;
    }
    
    .text_lefttoright-enter-active, .text_lefttoright-leave-active {
        transition: all 500ms;
    }
    .text_lefttoright-enter, .text_lefttoright-leave-to {
        opacity: 0;
    }
}
</style>
